export default __webpack_public_path__ + "static/Chugach-Mountains-73cb8c14e98bb94537e69dc9bccb8378.jpg";